//MUI
import {Alert,Box,Checkbox,Container,Divider,FormControl,FormControlLabel,Grid,InputLabel,MenuItem,Paper,Select,Stack,TextField,Typography} from "@mui/material";


const UTextField = (props) => {
  const name = props.name;
  const label = props.label;
  const mode = props.mode;
  const disabled = props.disabled;

  return(
      createUTextField(props)
  );
};
export default UTextField;

function createUTextField(obj){

  if(obj.mode==='detail'){
      return (
          <TextField
          name={obj.id}
          size="small"
          id="standard-read-only-input"
          InputProps={{
              readOnly: false,
              style: {fontSize: 14}
          }}
          variant="standard"
          value={obj.value}
          onChange={obj.onChange}
          />
      );

  }else{
      return (
      <FormControl sx={{ maxWidth: 191, }}size="small">
          <TextField
            size="small"
            variant="outlined"
            id="outlined-basic"
            label={obj.label||""}
            name={obj.name}
            onChange={obj.onChange}
            defaultValue={obj.defaultValue||""}
            disabled={obj.disabled || false}
            inputProps={{style: {fontSize: 13, paddingBottom:"5px", paddingtop:"5px"}}}
          />
      </FormControl>);
  }
};
